<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :products="products"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/TldMappings/Form'
import { route } from '~@/Composables/route'

defineProps({
    products: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.post(route('products.tld-product-mappings.store'))
}
</script>
